// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3UVTQ","validationTips":"StatementDescriptor_validationTips__1g1O2"};